<template>
  <div class="result-12">
    <img
      class="img"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-05/92be5599b67bc5cb153ba24fbf837df7_wh=1500_2880.png"
      alt=""
    />
    <div class="close" @click="bindClose"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClose() {
      if (this.$betterwe.isApp()) {
        this.$betterwe.onAppCloseRoute()
      } else {
        window['wx']['closeWindow']()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.result-12 {
  width: 100vw;
  position: relative;
  z-index: 1;
  min-height: 100vh;
  background-color: #f9f9f9;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img {
    width: 100%;
    box-sizing: border-box;
    display: block;
  }
  .close {
    width: 265px;
    height: 44px;
    position: absolute;
    top: 614px;
  }
}
</style>
